import { Grid, Tooltip, Typography } from '@cmg/design-system';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import React from 'react';

import { WobbleIcon } from './OfferingSuggestionRenderer.styles';

type Props = {
  relevanceReason: string;
};

const OfferingSuggestionRenderer: React.FC<Props> = ({ relevanceReason }) => {
  return (
    <div>
      <Tooltip
        title={
          <Grid maxWidth={theme => theme.spacing(50)}>
            <Typography variant="tooltip">{relevanceReason}</Typography>
          </Grid>
        }
        placement="top-start"
        variant="info"
      >
        <WobbleIcon>
          <Typography
            color={themes => themes.palette.primary.light}
            paddingLeft={0}
            paddingBottom={0.3}
            fontSize={themes => themes.typography.h3.fontSize}
            display="flex"
          >
            <AutoAwesomeIcon fontSize="inherit" />
          </Typography>
        </WobbleIcon>
      </Tooltip>
    </div>
  );
};

export default OfferingSuggestionRenderer;
